import { render } from "./RenderConfig.vue?vue&type=template&id=39917c88"
import script from "./RenderConfig.vue?vue&type=script&lang=js"
export * from "./RenderConfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__